module.exports = __webpack_public_path__ + "img/2017 (1).d5502675.jpg";